/**
 * Created by sergeys on 12.04.2017.
 */
import { Injectable } from '@angular/core';
import { RequestTypes } from './models/enums/request-types.enum';
import { Configuration } from './app.config';
import { DictionaryNum } from './models/dictionary';

@Injectable()
export class HttpConfiguration {
    public servers: DictionaryNum<string>;

    constructor(private readonly cfg: Configuration) {
        this.servers = new DictionaryNum<string>();

        // Internal
        this.servers[RequestTypes.InternalApi] = '/';

        // Http
        this.servers[RequestTypes.Http] = '';

        // Kartina Proxy API
        this.servers[RequestTypes.KartinaApiProxy] = cfg.appSettings.urls.kartinaApiProxyUrl;

        // Content API
        let contentApiUrl = cfg.appSettings.urls.contentApiUrl;
        if (contentApiUrl[contentApiUrl.length - 1] !== '/') {
            contentApiUrl += '/';
        }
        this.servers[RequestTypes.ContentApi] = contentApiUrl;
    }
}


// WEBPACK FOOTER //
// ./src/app/app.http.config.ts